<div *ngIf="conceptList.length > 0" >
    <app-bar-chart [barData]="conceptList" [showPercentage]="true"></app-bar-chart>
</div>